import { planTypes } from '@/common/constants';
import { checkCorporateDomain } from '@/apis/signing';
import Vue from 'vue';
import ZcmPurchaseBlockedDialog from '@/components/zcm-purchase-blocked-dialog.vue';

class ZcmDomainCheckService {
  constructor() {
    this.hasChecked = false;
    this.dialogInstance = null;
  }

  init(store) {
    this.store = store;
    
    store.watch(
      (state, getters) => ({
        cartIsReady: getters.cartIsReady,
        account: getters.account,
        getSelectedPlans: getters.getSelectedPlans,
      }),
      (newVal) => {
        this.tryCheckZcm(newVal);
      },
      { deep: true }
    );
  }

  tryCheckZcm({ cartIsReady, account, getSelectedPlans }) {
    if (this.hasChecked) {
      return;
    }

    if (!window.$context?.is?.loggedIn) {
      return;
    }

    if (!cartIsReady || !account?.email) {
      return;
    }

    const hasZoomComplianceManager = getSelectedPlans.some(plan => 
      plan.type === planTypes.ZCM
    );

    if (!hasZoomComplianceManager) {
      return;
    }

    this.hasChecked = true;
    this.checkDomain(account.email);
  }

  async checkDomain(userEmail) {
    try {
      const response = await checkCorporateDomain(userEmail);
      const shouldBlock = response?.result;
      
      if (shouldBlock) {
        const signInSource = this.store.getters.signInSource;
        
        if (signInSource === 'modal') {
          this.store.dispatch('removePlanByKey', { key: 'ZCM', force: true });
          this.store.commit('setZcmDomainWarning', true);
        } else {
          this.showDialog();
        }
      }
    } catch (error) {
      console.warn('Failed to check corporate domain on page load:', error);
    }
  }

  showDialog() {
    if (this.dialogInstance) {
      return;
    }

    const DialogConstructor = Vue.extend(ZcmPurchaseBlockedDialog);
    this.dialogInstance = new DialogConstructor({
      propsData: {
        visible: true
      }
    });

    this.dialogInstance.$on('close', () => {
      this.handleDialogClose();
    });

    this.dialogInstance.$mount();
    document.body.appendChild(this.dialogInstance.$el);
  }

  handleDialogClose() {
    if (this.dialogInstance) {
      this.store.dispatch('removePlanByKey', { key: 'ZCM', force: true });
      this.dialogInstance.$destroy();
      document.body.removeChild(this.dialogInstance.$el);
      this.dialogInstance = null;
    }
  }
}

const zcmDomainCheckService = new ZcmDomainCheckService();

export default zcmDomainCheckService;
